<template>
	<div class="p4 bg5 b1 bc7 r2 flex xs-12" v-if="hasEntity && amount">
		<div class="xs-12 flex fs3 ta1">
			<div class="xs-6">
				Commission for <span class="fw7">{{ name }}</span>
			</div>
			<div class="xs-6 ta3">
				<span class="fw7">{{ ratio }}%</span> is
				<span class="fw7"> {{ currency }}{{ amount }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currencyRates: [
				{ code: "AED", rate: 0.27 },
				{ code: "AUD", rate: 0.77 },
				{ code: "BND", rate: 0.76 },
				{ code: "EUR", rate: 1.23 },
				{ code: "IDR", rate: 0.00007 },
				{ code: "INR", rate: 0.015 },
				{ code: "KRW", rate: 0.00094 },
				{ code: "LKR", rate: 0.0064 },
				{ code: "MUR", rate: 0.03 },
				{ code: "MYR", rate: 0.26 },
				{ code: "PHP", rate: 0.019 },
				{ code: "PKR", rate: 0.0086 },
				{ code: "QAR", rate: 0.27 },
				{ code: "SAR", rate: 0.27 },
				{ code: "SGD", rate: 0.76 },
				{ code: "THB", rate: 0.032 },
				{ code: "USD", rate: 1 },
				{ code: "TWD", rate: 0.034 },
				{ code: "CNY", rate: 0.16 },
				{ code: "JPY", rate: 0.0094 },
				{ code: "OMR", rate: 2.6 },
				{ code: "HKD", rate: 0.13 },
				{ code: "GBP", rate: 1.41 }
			]
		}
	},

	computed: {
		commissionSummary() {
			return this.$store.getters["caseManagement/offer"]?.commissionSummary?.[0]
		},

		hasEntity() {
			return this.commissionSummary?.entity ? true : false
		},

		name() {
			return this.commissionSummary?.entity?.name || ""
		},

		ratio() {
			if (
				this.commissionSummary?.ratio !== undefined &&
				this.commissionSummary?.ratio !== null
			) {
				return (this.commissionSummary?.ratio * 100).toFixed(2)
			}
			return ""
		},

		amount() {
			// Recalculate to proper currency
			const amount = this.commissionSummary?.amount || 0
			const currencyRate =
				this.currencyRates.find(item => item.code === this.currency)?.rate || 0
			const recalculatedAmount = amount * (1 / currencyRate)
			return recalculatedAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") //format number
		},

		currency() {
			return this.$store.state.caseManagement?.case?.facts?.find(
				fact => fact.type === "premiumCurrency"
			)?.value?.stringValue
		}
	}
}
</script>
